export const WORKWISE_DARK_MODE_KEY = 'darkMode';
export const MILEMINDMAP_DARK_MODE_KEY = 'isDarkMode';

const readKey = (key) => {
  try {
    return localStorage.getItem(key);
  } catch (error) {
    return null;
  }
};

const parseFlag = (raw) => {
  if (raw === null || raw === undefined) return null;
  if (raw === 'true' || raw === '1') return true;
  if (raw === 'false' || raw === '0') return false;
  return null;
};

export const isDarkModeEnabled = () =>
  parseFlag(readKey(WORKWISE_DARK_MODE_KEY)) === true ||
  parseFlag(readKey(MILEMINDMAP_DARK_MODE_KEY)) === true;

export const setDarkModeEnabled = (enabled) => {
  const next = Boolean(enabled);
  try {
    localStorage.setItem(WORKWISE_DARK_MODE_KEY, String(next));
    localStorage.setItem(MILEMINDMAP_DARK_MODE_KEY, JSON.stringify(next));
  } catch (error) {
    console.error('Error persisting dark mode:', error);
  }
};
